import React from "react";
import dynamic from 'next/dynamic'

//import Banner from "../../cezBanner/index";
const Banner = dynamic(() => import("../../cezBanner/index"));

import styles from "../../../styles/pages/cezPage.module.scss";
//import Icons from "../../../public/assets/svg/index";
const Icons = dynamic(() => import("../../../public/assets/svg/index"));

const Cez = dynamic(() => import("../../cez1"));

//import Cez from "../../cez1";

import endPoints from "../../../utility/endpoints";
import _get from "lodash/get";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useRouter } from "next/router";
//import gsap from "gsap";
//import { ScrollTrigger } from "gsap/dist/ScrollTrigger";
// import ScrollTrigger from "gsap/ScrollTrigger";

export default function index(props) {



  const router = useRouter();

  //console.log("props at cez", props);

  const backgroundUrlMobile = _get(
    props.data[0],
    "component.content.field_background_image_mobile[0]",
    ""
  );
  const backgroundUrl = _get(
    props,
    "data[0]component.content.field_background_image[0].file_url",
    ""
  );

  const cezDetails = _get(
    props,
    "data[0].component.content.field_details",
    ""
  );
  const cezHeading = _get(
    props,
    "data[0]component.content.field_hedaing",
    ""
  );
  const imageUrlWhat = _get(
    props,
    "data[1]component.content.field_image[0].file_url",
    ""
  );
  // const messageWhat = _get(
  //   props.data[1],
  //   "component.content.field_message_input",
  //   ""
  // );
  // const titleWhat = _get(props.data[1], "component.content.field_title", "");
  const imageUrlMobileWhat = _get(
    props,
    "data[1]component.content.field_image_mobile[0].file_url",
    ""
  );

  // content

  const cez1Info = _get(props, "data[2].component.content", "");
  const cez2Info = _get(props, "data[3].component.content", "");
  const cez3Info = _get(props, "data[4].component.content", "");
  const cez4Info = _get(props, "data[5].component.content", "");
  const cez5Info = _get(props, "data[6]component.content", "");
  const cez6Info = _get(props, "data[7]component.content", "");
  const cez7Info = _get(props, "data[8]component.content", "");

  const allCezNavs = [cez1Info, cez2Info, cez3Info, cez4Info, cez5Info, cez6Info, cez7Info];

  const [cez1, setcez1] = React.useState(true);
  const [cez2, setcez2] = React.useState(false);
  const [cez3, setcez3] = React.useState(false);
  const [cez4, setcez4] = React.useState(false);
  const [cez5, setcez5] = React.useState(false);
  const [imageactive, setimageactive] = React.useState("/assets/svg/frame1_bottom.svg");
  const [imagetop, setimagetop] = React.useState("/assets/svg/frame1_top.svg");
  const [shownav, setshownav] = React.useState(false);
  const [showtop, setshowtop] = React.useState(true);
  const [stage, setStage] = React.useState("1")

  let initialCezState = { 0: false, 1: false, 2: false, 3: false, 4: false,5: false,6: false };
  const bannerRef = React.useRef(null)

  const [cezState, setCezState] = React.useState({
    ...initialCezState,
    0: true,
  });

  const cezClicked = (index) => {
    setCezState({ ...initialCezState, [index]: true });
  };
  const [sticky, setsticky] = React.useState(false);
  React.useEffect(() => {
    window.onscroll = function () {
      myFunction();
    };
  }, []);

  React.useEffect(() => {
    //console.log('router ----', router.query.cezSection);
    debugger;
    if (router.query.cezSection) {
      // window.scrollTo({
      //   top: 840,
      // });
      setshownav(true)
      //   alert("yahn tak sab sahi hai")

      switch (router.query.cezSection) {
        case "RPA":

          setCezState({ ...initialCezState, 0: true });
          break;
        case "Conversational AI":

          setCezState({ ...initialCezState, 1: true });
          break;

        case "Text classification & analytics":
          setCezState({ ...initialCezState, 2: true });
          break;

        case "Anomaly detection service":
          setCezState({ ...initialCezState, 3: true });
          break;

        case "Image and video analytics":
          setCezState({ ...initialCezState, 4: true });
          break;

        case "Document digitization":
          setCezState({ ...initialCezState, 5: true });
          break;
        case "Web scrapping":
          setCezState({ ...initialCezState, 6: true });
          break;
      }

    }

  }, [router.query])

  function myFunction() {
    var header = document.getElementById("mohit");

    var stickydiv = null;
    if (header) {
      stickydiv = header.offsetTop;
    }
    //console.log("mohittttttttttt",stickydiv,window.pageYOffset,window.pageYOffset > sticky);
    if (window.pageYOffset > 1000) {
      if (header) {

        header.classList.add(styles.sticky);
      }
      // console.log("kritikaaaaaaaaaaaaaa",);
      setsticky(true);
    } else {
      if (header) {
        header.classList.remove(styles.sticky);
      }

      setsticky(false);
    }
  }

  const handlePage = (e, index) => {
    setCezState({ ...initialCezState, [index]: true });
    //bannerRef.current.scrollIntoView() 
    window.scrollTo(0, 0)
  };


  const cezIconClicked = (index) => {

    setCezState({ ...initialCezState, [index]: true });
    setshownav(true)
    window.scrollTo(0, 0)

    // window.scrollTo({
    //   top: 0
    // })
  }

  const [showHideNav, setShowHidNav] = React.useState(true)

  //console.log(allCezNavs)

  return (
    <div className={styles.cezContainer}>
      {shownav ? null : (
        <Banner data={{ cezDetails, cezHeading, backgroundUrl, backgroundUrlMobile }} />
      )}

      <div className={styles.mainHeading}>
        {/* {shownav ? null : (
          <>
            <p className={styles.head}>{titleWhat}</p>
            <p className={styles.text}>{messageWhat}</p>
          </>
        )} */}

        {shownav ? (
          <>
            
            {
              showHideNav ?

                <div className={`${styles.submenu} container-fluid`}>
                  <div className="container">
                    <div className="row">
                      <div className="col-12 flexy-sbc hw-100">
                        <div onClick={() => setshownav(false)}>
                          {/* <LazyLoadImage src="/assets/svg/cezback.png" /> */}
                        </div>
                        {allCezNavs.map((item, index) => (
                          <div
                            className={
                              cezState[index]
                                ? `${styles.iconDiv}  ${styles[`active${index}`]}`
                                : `${styles.iconDiv}`
                            }
                            onClick={(e) => {
                              handlePage(e, index);
                            }}>
                            <a
                              rel="noreferrer"
                            // onClick={() => {
                            //   window.scrollTo({
                            //     top: 840,
                            //   });
                            // }}
                            >
                              <LazyLoadImage
                                src={
                                  cezState[index]
                                    ? `${endPoints.drupalIp}${_get(item, "field_active_image_icon[0].file_url", "")}`
                                    : `${endPoints.drupalIp}${_get(item, "field_icon_image[0].file_url", "")}`
                                } />
                              <span className={styles.cezheading}>{_get(item, "field_title", "")}</span>
                            </a>
                          </div>
                        ))}
                        
                      </div>
                    </div>
                  </div>
                </div>
                : null}
          </>
        ) : (
          <>
            <div className={`${styles.cezMainContainer} container`}>
              <div className={styles.cezCircleOuter}>
                <LazyLoadImage
                  src="/assets/svg/unilever.svg"
                  className={styles.cezMainCircle}
                  alt="cezcircle"
                />
                <div className={styles.cezCircleLine}></div>
              </div>

              <div className={styles.cezIcons}>
                <div className={styles.cezIconOuter}>
                  <div
                    className={styles.cezIcon}
                    onClick={() => {
                      cezIconClicked(0);
                    }}
                  >
                    <div className={styles.cezIconDefault}>
                      <Icons name="RPA" />
                    </div>
                    <div className={styles.cezIconActive}>
                      <LazyLoadImage
                        src="/assets/svg/rpa-selected.png"
                        alt="none"
                      />
                    </div>
                    <p className={styles.cezIconText}>RPA</p>
                  </div>
                  <LazyLoadImage
                    src="/assets/svg/Green-bullet.png"
                    className={styles.bulletIcon}
                  />
                </div>
                <div className={styles.cezIconOuter}>
                  <div
                    className={styles.cezIcon}
                    onClick={() => {
                      cezIconClicked(1);
                    }}
                  >
                    <div className={styles.cezIconDefault}>
                      <Icons name="ConversationalAi" />
                    </div>
                    <div className={styles.cezIconActive}>
                      <LazyLoadImage
                        src="/assets/svg/conversational-ai-selected.png"
                        alt="none"
                      />
                    </div>
                    <p className={styles.cezIconText}>Conversation AI</p>
                  </div>
                  <LazyLoadImage
                    src="/assets/svg/Blue-bullet.png"
                    className={styles.bulletIcon}
                  />
                </div>

                <div className={styles.cezIconOuter}>
                  <div
                    className={styles.cezIcon}
                    onClick={() => {
                      cezIconClicked(2);
                    }}
                  >
                    <div className={styles.cezIconDefault}>
                      <Icons name="TestClassification" />
                    </div>
                    <div className={styles.cezIconActive}>
                      <LazyLoadImage src="/assets/svg/Test-Classification-Analytics-default-selected.png" />
                    </div>

                    <p className={styles.cezIconText}>Text Classification & Analytics</p>
                  </div>
                  <LazyLoadImage
                    src="/assets/svg/Green-bullet.png"
                    className={styles.bulletIcon}
                  />

                </div>

                <div className={styles.cezIconOuter}>
                  <div
                    className={styles.cezIcon}
                    id="cezAnime3"
                    onClick={() => {
                      cezIconClicked(3);
                    }}
                  >
                    <div className={styles.cezIconDefault}>
                      <Icons name="AnomalyDetection" />
                    </div>
                    <div className={styles.cezIconActive}>
                      <LazyLoadImage src="/assets/svg/Anomaly-Detection-Service-selected.png" />
                    </div>
                    <p className={styles.cezIconText}>Anomaly Detection Service</p>
                  </div>
                  <LazyLoadImage
                    src="/assets/svg/Purple-bullet.png"
                    className={styles.bulletIcon}
                  />

                </div>

                <div className={styles.cezIconOuter}>
                  <div
                    className={styles.cezIcon}
                    onClick={() => {
                      cezIconClicked(4);
                    }}
                  >
                    <div className={styles.cezIconDefault}>
                      <Icons name="ImgVdoAnalytics" />
                    </div>
                    <div className={styles.cezIconActive}>
                      <LazyLoadImage src="/assets/svg/Image-Video-Analytics-selected.png" />
                    </div>
                    <p className={styles.cezIconText}>Image and Video Analytics</p>
                  </div>
                  <LazyLoadImage
                    src="/assets/svg/Red-bullet.png"
                    className={styles.bulletIcon}
                  />

                </div>

                <div className={styles.cezIconOuter}>
                  <div
                    className={styles.cezIcon}
                    onClick={() => {
                      cezIconClicked(5);
                    }}
                  >
                    <div className={styles.cezIconDefault}>
                      <Icons name="DocumentDigitalization" />
                    </div>
                    <div className={styles.cezIconActive}>
                      <LazyLoadImage src="/assets/svg/Document-Digitization-selected.png" />
                    </div>

                    <p className={styles.cezIconText}>Document Digitization</p>

                  </div>
                  <LazyLoadImage
                    src="/assets/svg/Pink-bullet.png"
                    className={styles.bulletIcon}
                  />

                </div>
                <div className={styles.cezIconOuter}>
                  <div
                    className={styles.cezIcon}
                    onClick={() => {
                      cezIconClicked(6);
                    }}
                  >
                    <div className={styles.cezIconDefault}>
                      <Icons name="WebScrapping" />
                    </div>
                    <div className={styles.cezIconActive}>
                      <LazyLoadImage src="/assets/svg/webscrapping-selected.png" />
                    </div>

                    <p className={styles.cezIconText}>Web Scrapping</p>

                  </div>
                  <LazyLoadImage
                    src="/assets/svg/Blue-bulletnew.png"
                    className={styles.bulletIcon}
                  />
                </div>
              </div>
            </div>
          </>

        )}
      </div>
      {/* cez nav mobile */}

      {
        shownav ? null :
          <div className={styles.mobileView}>
            <div className={styles.diagramWrappermobile}>
              {/* <LazyLoadImage src={endPoints.drupalIp + imageUrlMobileWhat} /> */}
              <div onClick={() => { cezIconClicked(0); }}><LazyLoadImage src="/assets/svg/rpa-mobile-individual.png" /> </div>
              <div onClick={() => { cezIconClicked(1); }}><LazyLoadImage src="/assets/svg/conversational-ai-mobile-individual.png" /> </div>
              <div onClick={() => { cezIconClicked(2); }}> <LazyLoadImage src="/assets/svg/test-classification-analytics-mobile-individual.png" /></div>
              <div onClick={() => { cezIconClicked(3); }}>  <LazyLoadImage src="/assets/svg/anomaly-detection-service-mobile-individual .png" /></div>
              <div onClick={() => { cezIconClicked(4); }}> <LazyLoadImage src="/assets/svg/image-video-analytics-mobile-individual.png" /></div>
              <div onClick={() => { cezIconClicked(5); }}><LazyLoadImage src="/assets/svg/document-digitization-mobile-individual.png" /></div>
              <div onClick={() => { cezIconClicked(6); }}><LazyLoadImage src="/assets/svg/web-scrapping-mobile-individual.png" /></div>
              <div className={styles.verticalLine}></div>
            </div>
            <div className={styles.para}>
              <div className={styles.bundle} onClick={() => { cezIconClicked(0); }}>
                <p className={styles.cezhead}>RPA</p>
                <span>
                  <LazyLoadImage src="/assets/svg/cezarrow2.png" />
                </span>
              </div>
              <div className={styles.bundle} onClick={() => { cezIconClicked(1); }}>
                <p className={styles.cezhead}>Conversational AI</p>
                <span>
                  <LazyLoadImage src="/assets/svg/cezarrow1.png" />
                </span>
              </div>

              <div className={styles.bundle} onClick={() => {
                cezIconClicked(2);
              }}>
                <p className={styles.cezhead}>Test Classification & Analytics</p>
                <span>
                  <LazyLoadImage src="/assets/svg/cezarrow2.png" />
                </span>
              </div>

              <div className={styles.bundle} onClick={() => {
                cezIconClicked(3);
              }}>
                <p className={styles.cezhead}>Anomaly Detection Service</p>
                <span>
                  <LazyLoadImage src="/assets/svg/cezarrow3.png" />
                </span>
              </div>

              <div className={styles.bundle} onClick={() => {
                cezIconClicked(4);
              }}>
                <p className={styles.cezhead}>Image and Video Analytics</p>
                <span>
                  <LazyLoadImage src="/assets/svg/cezarrow4.png" />
                </span>
              </div>

              <div className={styles.bundle} onClick={() => {
                cezIconClicked(5);
              }}>
                <p className={styles.cezhead}>Document Digitization</p>
                <span>
                  <LazyLoadImage src="/assets/svg/cezarrow5.png" />
                </span>
              </div>
              <div className={styles.bundle} onClick={() => {
                cezIconClicked(6);
              }}>
                <p className={styles.cezhead}>Web Scrapping</p>
                <span>
                  <LazyLoadImage src="/assets/svg/cezarrow1.png" />
                </span>
              </div>
            </div>
          </div>}


      {cezState["0"] && shownav ? (
        <div className={styles.dummydiv} id="intro-bannar">
          <Cez data={cez1Info} pageNum={1} setshownav={setshownav} bannerRef={bannerRef} />
        </div>
      ) : cezState["1"] && shownav ? (
        <div className={styles.dummydiv} id="intro-bannar">
          <Cez data={cez2Info} pageNum={2} setshownav={setshownav} bannerRef={bannerRef} />
        </div>
      ) : cezState["2"] && shownav ? (
        <div className={styles.dummydiv} id="intro-bannar">
          <Cez data={cez3Info} pageNum={3} setshownav={setshownav} bannerRef={bannerRef} />
        </div>
      ) : cezState["3"] && shownav ? (
        <div className={styles.dummydiv} id="intro-bannar">
          <Cez data={cez4Info} pageNum={4} setshownav={setshownav} bannerRef={bannerRef} />
        </div>
      ) : cezState["4"] && shownav ? (
        <div className={styles.dummydiv} id="intro-bannar">
          <Cez data={cez5Info} pageNum={5} setshownav={setshownav} bannerRef={bannerRef} />
        </div>
      ) : cezState["5"] && shownav ? (
        <div className={styles.dummydiv} id="intro-bannar">
          <Cez data={cez6Info} pageNum={6} setshownav={setshownav} bannerRef={bannerRef} />
        </div>
      ) : cezState["6"] && shownav ? (
        <div className={styles.dummydiv} id="intro-bannar">
          <Cez data={cez7Info} pageNum={7} setshownav={setshownav} bannerRef={bannerRef} />
        </div>
      ) : null}
    </div>
  );
}
